/* eslint-disable no-param-reassign */
import packageInfo from '../../../package.json';
import { PLUGIN_NAME } from './constants';
import boostQuery from './boostQuery';

const { version } = packageInfo;

async function load(app) {
  app.log.debug('loaded list-query-variables-plugin');

  app.events.on('plugin:page-builder:list:query-variables:sync', async ({ data = {} }) => {
    try {
      boostQuery(data);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('List query update error', e);
    }
  });

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
